export default "__VITE_ASSET__XUzfdZH4__"